import * as React from 'react';

import NavTabs from '@app/components/UI/NavTabs/NavTabs';

const TabsInfoBlock = ({navItems, currentIndex, onSetIssue, navCollapse, currentIssue}) => {
	return (
		<div className="tabs-info-block">
			<h3 className="tabs-info-block__title">More information about the job</h3>
			<NavTabs
				navItems={navItems}
				currentIndex={currentIndex}
				onSetIssue={onSetIssue}
				navCollapse={navCollapse}
				onChange={onSetIssue}
			/>
			{navItems[currentIndex].name === 'experience' &&
				<p className="tabs-info-block__phrase">
					While we welcome all different backgrounds, the VCC's with the most success tend to have the following:
				</p>
			}
			<ul className="tabs-info-block__list">
				{
					currentIssue.map((item, index) => (
						<li key={index}>
							{
								!item.url ? item.title :
									
								<a href={item.url} target="_blank">
									{item.title}
								</a>
								
							}
						</li>
					))
				}
				
			</ul>
		</div>
	);
};

export default TabsInfoBlock;